import PropTypes from "prop-types";
import { Icon } from "@iconify/react";
import { tokens } from "../tokens";

// Icon from the GymRite set (src/design-system/icons.js). Colour follows the text (currentColor).
// Decorative by default (aria-hidden); pass `title` when the icon carries meaning on its own.
export default function GrIcon({ icon, size = "lg", title, style, ...rest }) {
  const px = tokens.icon[size] || tokens.icon.lg;
  return (
    <Icon
      icon={icon}
      width={px}
      height={px}
      aria-hidden={title ? undefined : true}
      role={title ? "img" : undefined}
      aria-label={title}
      style={{ flex: "none", ...style }}
      {...rest}
    />
  );
}

GrIcon.propTypes = {
  icon: PropTypes.object.isRequired,
  size: PropTypes.oneOf(["sm", "md", "lg", "xl"]),
  title: PropTypes.string,
  style: PropTypes.object,
};
